// extracted by mini-css-extract-plugin
module.exports = {"traitList":"AlpTraitsOverlay_traitList__3UkAf","image":"AlpTraitsOverlay_image__O9jWm"};